import ApiBase from './api-base'
import Tool from '../common/tool'
import ApiOss from './api-oss'

export default {
  ...ApiBase,
  model: 'video',
  async testSpeedVideoServer () {
    return new Promise(async (resolve, reject) => {
      let img = new window.Image()
      let btime = new Date().getTime()
      let imgSrc = await ApiOss.signatureUrl('hbyx/media/speed/speed.png', 'media')
      img.src = imgSrc
      img.onload = () => {
        let stime = new Date().getTime() - btime
        let speed = Tool._toFixed(112 / stime, 2)
        img = btime = stime = undefined
        resolve(speed)
      }
      img.onerror = (err) => {
        img = btime = undefined
        reject(err)
      }
    })
  }
}
